export const getCostChartConfig = (chartData: any) => {
  return chartData.details.map((item: any) => {
    if (item.name === "investObjectPriceWithFurniture") {
      return {
        id: item.name,
        label: item.name,
        value: item.value,
        rate: item.rate,
        color: "#0f74d8",
      };
    }
    if (item.name === "propertyTaxFee") {
      return {
        id: item.name,
        label: item.name,
        value: item.value,
        rate: item.rate,
        color: "#0db6c9",
      };
    }

    if (item.name === "financingNotaryAmount") {
      return {
        id: item.name,
        label: item.name,
        value: item.value,
        rate: item.rate,
        color: "#ffbe42",
      };
    }

    if (item.name === "purchaseNotaryAmount") {
      return {
        id: item.name,
        label: item.name,
        value: item.value,
        rate: item.rate,
        color: "#f00f38",
      };
    }

    if (item.name === "brokerFeeValue") {
      return {
        id: item.name,
        label: item.name,
        value: item.value,
        rate: item.rate,
        color: "#c149df",
      };
    }

    return {
      id: item.name,
      label: item.name,
      value: item.value,
      rate: item.rate,
      color: "#743983ff",
    };
  });
};
